import {capitalizeFirstLetter} from 'core/common/utils/stringUtils';
import {formatId} from "core/common/utils/utils";
import MdEntity from "core/metamodel/mdEntity";
import {formatNumber} from 'core/common/utils/numberUtils';
import {FILTEROPERATOR} from "core/grid/domain/grid";
import {formatDate, formatDateTime, formatPeriod} from "core/common/utils/dateUtils";
import {observable} from "mobx";
import mdEntityService from "core/metamodel/mdEntityService";


export enum VALUESOURCETYPE {
  LOCAL = "LOCAL",
  ASYNC = "ASYNC"
}


export enum DATATYPE {
  BOOLEAN = "BOOLEAN",
  NUMBER = "NUMBER",
  NUMBERCURRENCY = "NUMBERCURRENCY",
  STRING = "STRING",
  DATE = "DATE",
  TIME = "TIME",
  DATETIME = "DATETIME",
  PERIOD = "PERIOD",
  DURATION = "DURATION"
}


export enum TEXTALIGN {
  left = "left",
  right = "right",
  center = "center"
}

export enum FIELDTYPE {
  STANDARD = "STANDARD",
  UNMANAGED = "UNMANAGED",
  VIRTUAL = "VIRTUAL",
  URL = "URL",
  FUNCTION = "FUNCTION",
  SQLRESULT = "SQLRESULT",
  DYNAMIC = "DYNAMIC"
}

export enum DISPLAYTYPE {
  BUTTON = "BUTTON",
  ICON = "ICON",
  CHECKBOX = "CHECKBOX"
}



export interface MdFieldValidation {
  validation: string;
  parameters?: {[key: string]: any};
  qualifyExpr?: string;
}


export default class MdField {

  // reference na mdEntity
  $entityRef: MdEntity;

  // fieldName
  fieldName: string;

  // entityName
  entityName: string;

  // entityName_fieldName
  fieldKey: string;

  // main label
  label: string;

  // grid column label override
  gridHeaderLabel: string;

  // form label override
  formLabel: string;


  // main tooltip
  tooltip: string;

  // grid column tooltip override
  gridHeaderTooltip: string;

  // column can be displayed in grid
  visible: boolean;

  // column can be multiUpdated
  multiUpdate: boolean;

  // column can be used in grid filter
  filterable: boolean;

  // field is localized
  localized: boolean;

  /**
   * entityName of entity providing values
   */
  valueSource: string;

  // LOCAL x ASYNC
  valueSourceType: VALUESOURCETYPE;

  // available operators for grid filter conditions
  availableOperators: FILTEROPERATOR[];

  // default operator
  defaultOperator: FILTEROPERATOR;

  // route pro kliknuti na policko v gridu
  detailRoute: string;

  //   BOOLEAN, NUMBER, STRING, DATE,DATETIME
  dataType: DATATYPE;

  // left,right,center
  textAlign: TEXTALIGN;

  // FUNCTION, URL
  fieldType: FIELDTYPE;

  // BUTTON, ICON
  displayType: DISPLAYTYPE;

  // jmeno funkce pro FUNCTION fieldType
  functionName: string;

  // format pro optional formatovani cisla
  numberFormat: string;

  // max length pro textField
  maxLength: number;

/**
 * default value of a field, as a string
 */
  defaultValue: string;

  @observable searchTermType: FILTEROPERATOR;

  validations: MdFieldValidation[];

  $selected: boolean;

  constructor(json: any, mdEntity?: MdEntity) {
    this.fromJson(json);
    this.$entityRef = mdEntity;
  }


  protected fromJson(json: any): void {
    for(let key in json) {
      if (json.hasOwnProperty(key)) {
        this[key] = json[key];
      }
    }
    this.fieldKey = formatId(this.entityName, this.fieldName);
  }


  get gridHeaderLabelActive(): string {
    return (this.gridHeaderLabel != null) ? this.gridHeaderLabel : this.label;
  }

  get gridHeaderTooltipActive(): string {
    return (this.gridHeaderTooltip != null) ? this.gridHeaderTooltip : this.tooltip;
  }

  get formLabelActive(): string {
    return (this.formLabel != null) ? this.formLabel : this.label;
  }



  formatValue(value:any) {
    if (value != null && typeof value.label !== 'undefined') {
      return value.label;
    } else {
      switch (this.dataType) {
        case DATATYPE.DATE:
          return formatDate(value);
        case DATATYPE.DATETIME:
          return formatDateTime(value);
        case DATATYPE.NUMBER:
          return formatNumber(value, this.numberFormat);
        case DATATYPE.NUMBERCURRENCY:
          return (value) ? formatNumber(value.price, this.numberFormat) + ((value.currency) ? ' ' + value.currency:'') : value;
        case DATATYPE.BOOLEAN:
          return value == null ? '' : (value + '');
        case DATATYPE.PERIOD:
          return formatPeriod(value);
        case DATATYPE.DURATION:
          return formatPeriod(value, true);
        default:
          return (value) ? value.toString() : null;
      }
    }
  }

  hasLocalValueSource() {
    return (this.valueSource && this.valueSourceType ===  VALUESOURCETYPE.LOCAL);
  }

  functionNameGetter() {
    return 'get' + capitalizeFirstLetter(this.functionName);
  }

  functionNameSetter() {
    return 'set' + capitalizeFirstLetter(this.functionName);
  }

  initMuiInput(val: any) {
    return (this.valueSourceType || this.dataType === DATATYPE.DATE  || this.dataType === DATATYPE.DATETIME) ? val
      :  ((val == null) ? ((this.dataType === DATATYPE.BOOLEAN) ? false : '') : val);
  }

  computeDefaultValue(): any {
    if (this.defaultValue) {
      let _value =   (this.defaultValue.startsWith('#')) ? eval(this.defaultValue.substring(1)) : this.defaultValue;

      // musime z toho udelat lovItem
      if (this.hasLocalValueSource()) {
        let valueSourceEntity =  mdEntityService.getEntity(this.valueSource);
        if (valueSourceEntity) {
          _value = valueSourceEntity.lovItems.find(lov => lov.value.toString() === _value); // pozor defaultValue je String
        }
      }
      return _value;
    } else {
      return undefined;
    }

  }


}



// WEBPACK FOOTER //
// ./src/core/metamodel/mdField.ts